// extracted by mini-css-extract-plugin
export default {"p_tye":"_8568f444e8","slcted":"_09daa89823","slc_color":"ac43a77db3","item_p":"ffa276203d","r0":"_5f2ae1ee66"};